/** Whether a balance covers a price. Single definition so the card and detail page agree. */
export const canAfford = (balance: number, price: number): boolean => balance >= price;
